<script>
import TablePage from '@/found/components/table_page';
import DetailForm from '../form/detail.vue';
import Year from './year.vue';

export default {
  extends: TablePage,
  name: 'main_list',
  components: {
    DetailForm,
    Year,
  },
  data() {
    return {
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
    };
  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    beforeSearchEvent(val) {
      if (val.$event.type === 'reset') {
        this.searchFormData.year = '';
        this.formData.year = '';
        this.$emit('reset');
      }
      return true;
    },
    // 年份选择器改变事件
    changeYear(val) {
      this.searchFormData.year = val;
      this.formData.year = val;
    },
    beforeSetSearch(val) {
      const item = val;
      if (item.field === 'year') {
        item.typeName = 'Year';
        item.type = 'customSearch';
      }
      // const date = new Date();
      // const year = date.getFullYear();
      // const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // const day = date.getDate().toString().padStart(2, '0');
      // const currentDate = `${year}-${month}-${day}`;
      // if (
      //   !this.searchFormData.createTimeStart
      //   && !this.searchFormData.createTimeEnd
      // ) {
      //   this.searchFormData = {
      //     ...this.searchFormData,
      //     createTimeStart: `${currentDate} 00:00:00`,
      //     createTimeEnd: `${currentDate} 23:59:59`,
      //   };
      //   this.formData = {
      //     ...this.formData,
      //     createTimeStart: `${currentDate} 00:00:00`,
      //     createTimeEnd: `${currentDate} 23:59:59`,
      //   };
      // }
      return item;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (['detail'].includes(val.code)) {
        this.formConfig = {};
        this.formName = 'DetailForm';
        this.modalConfig.width = '85%';
        this.modalConfig.title = '明细';
        this.formConfig = {
          row,
          code: val.code || '',
        };
        this.openFull();
      }
    },
  },
};
</script>
